import gql from 'graphql-tag'
import { main } from './fragments'

export default gql`
mutation createSalesGroup($required: SalesGroupReqFields!, $fields: SalesGroupFields) {
	cashAssist {
		createMutation: createSalesGroup(required: $required, fields: $fields) {
			...salesGroupMain
		}
	}
}
${main}`
